import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "card-header pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_inbound_receiving_package"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "card-body pb-0" }
const _hoisted_8 = { class: "overflow-auto" }
const _hoisted_9 = { class: "table align-top table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_10 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, null, -1)
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "fw-bold text-gray-800" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "d-flex flex-column gap-7 text-dark py-4 px-5" }
const _hoisted_21 = { class: "fs-7 fw-bold text-gray-500" }
const _hoisted_22 = { class: "fw-bolder" }
const _hoisted_23 = { class: "fs-7 fw-bold text-gray-500" }
const _hoisted_24 = { class: "fw-bolder" }
const _hoisted_25 = { class: "fs-7 fw-bold text-gray-500" }
const _hoisted_26 = { class: "d-flex flex-column gap-1 fw-bolder" }
const _hoisted_27 = { class: "svg-icon svg-icon-2 svg-icon-primary ms-1" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "d-flex justify-content-end" }
const _hoisted_31 = { class: "mw-125px d-flex flex-column" }
const _hoisted_32 = {
  key: 0,
  class: "el-input-number el-input-number--small w-125px"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M128 544h768a32 32 0 100-64H128a32 32 0 000 64z"
    })
  ])
], -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M480 480V128a32 32 0 0164 0v352h352a32 32 0 110 64H544v352a32 32 0 11-64 0V544H128a32 32 0 010-64h352z"
    })
  ])
], -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "fs-7 text-primary text-nowrap mt-2"
}
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = {
  key: 0,
  class: "fs-7 text-primary text-nowrap mt-2"
}
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "svg-icon svg-icon-3" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  colspan: "7",
  class: "text-center"
}
const _hoisted_53 = {
  colspan: "2",
  class: "text-end"
}
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = {
  key: 0,
  class: "text-center"
}
const _hoisted_56 = { class: "d-flex justify-content-end" }
const _hoisted_57 = { class: "w-125px" }
const _hoisted_58 = {
  key: 1,
  class: "text-end"
}
const _hoisted_59 = { class: "text-end" }
const _hoisted_60 = { class: "text-end" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_62 = { class: "d-flex align-items-center justify-content-end gap-4" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "svg-icon svg-icon-2" }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "svg-icon svg-icon-2" }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_73 = { class: "card-header pt-5" }
const _hoisted_74 = { class: "card-title align-items-start flex-column" }
const _hoisted_75 = { class: "card-body pb-0" }
const _hoisted_76 = { class: "overflow-auto" }
const _hoisted_77 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_78 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_79 = { class: "text-start" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, null, -1)
const _hoisted_81 = { class: "text-end" }
const _hoisted_82 = { class: "text-end" }
const _hoisted_83 = { class: "fw-bold text-gray-800" }
const _hoisted_84 = {
  key: 0,
  class: "w-100"
}
const _hoisted_85 = { class: "d-flex align-items-center" }
const _hoisted_86 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_87 = { class: "symbol-label" }
const _hoisted_88 = { class: "svg-icon svg-icon-1" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { class: "text-end" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "text-end" }
const _hoisted_93 = {
  key: 0,
  class: "d-flex justify-content-end gap-2"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "svg-icon svg-icon-3" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_98 = { class: "d-flex align-items-center justify-content-end gap-4" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "svg-icon svg-icon-2" }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { class: "svg-icon svg-icon-2" }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_109 = { class: "card-header pt-5" }
const _hoisted_110 = { class: "card-title align-items-start flex-column" }
const _hoisted_111 = { class: "fs-6 text-gray-400" }
const _hoisted_112 = { class: "card-body pb-0" }
const _hoisted_113 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_114 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_115 = { class: "text-start" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, null, -1)
const _hoisted_117 = { class: "text-end" }
const _hoisted_118 = { class: "text-end" }
const _hoisted_119 = { class: "text-end" }
const _hoisted_120 = { class: "fw-bold text-gray-800" }
const _hoisted_121 = { class: "text-start" }
const _hoisted_122 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_123 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_124 = { class: "fs-7 text-gray-400 text-uppercase" }
const _hoisted_125 = { class: "text-end" }
const _hoisted_126 = { class: "text-end" }
const _hoisted_127 = { class: "text-danger" }
const _hoisted_128 = { class: "text-end" }
const _hoisted_129 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "svg-icon svg-icon-3" }
const _hoisted_132 = { key: 0 }
const _hoisted_133 = {
  colspan: "6",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_edit_double_sale_article_guid = _resolveComponent("edit-double-sale-article-guid")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_InboundReceivingPackageModal = _resolveComponent("InboundReceivingPackageModal")!
  const _component_update_double_sale_article = _resolveComponent("update-double-sale-article")!
  const _component_mismatched_sku = _resolveComponent("mismatched-sku")!
  const _component_missing_result = _resolveComponent("missing-result")!
  const _component_exception_product = _resolveComponent("exception-product")!
  const _component_print_preview = _resolveComponent("print-preview")!
  const _directive_clickOutSide = _resolveDirective("clickOutSide")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspection.stockIn")), 1)
        ]),
        (_ctx.isEditStockIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.overviewChecking")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_10, [
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.t("order.article")), 1),
                _hoisted_12,
                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.t("inspection.demand")), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.t("order.qtyReceived")), 1),
                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.t("inspection.missingQty")), 1),
                _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.t("inspection.stocked")), 1),
                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.t("common.action")), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.article, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_product_info, {
                      gallery: item.gallery,
                      name: item.name,
                      name_en: item.name_en,
                      source_link: '',
                      brand_id: item.__show.brand_id
                    }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_sku_info, {
                        brand_article_no: item.brand_article_no,
                        merchant_article_no: item.merchant_article_no,
                        color: item.original_color,
                        size: item.__show.size,
                        capacity: item.__show.capacity,
                        product_identifier_id: item.product_identifier_id
                      }, null, 8, ["brand_article_no", "merchant_article_no", "color", "size", "capacity", "product_identifier_id"]),
                      (item.custom_number.length > 0)
                        ? (_openBlock(), _createBlock(_component_el_popover, {
                            key: 0,
                            placement: "top",
                            width: "300px",
                            trigger: "hover"
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("span", _hoisted_27, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("order.brandArticleNumber")), 1),
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.brand_article_no), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("order.posArticleNumber")), 1),
                                  _createElementVNode("div", _hoisted_24, _toDisplayString(item.merchant_article_no), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("order.customNumber")), 1),
                                  _createElementVNode("div", _hoisted_26, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.custom_number, (row, key) => {
                                      return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(row), 1))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(item.demand_quantity), 1),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.isEditStockIn)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.formData.double_sale === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createVNode(_component_el_popover, {
                                      "popper-class": "double-sale-guid",
                                      width: "568px",
                                      placement: "bottom-end",
                                      disabled: 
                            _ctx.itemIndex !== index ||
                            _ctx.getDoubleSaleArticleItemGuids(index).length <
                              item.received_quantity
                          ,
                                      visible: _ctx.options.showEditGuids
                                    }, {
                                      reference: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["el-input-number__decrease", {
                                  'is-disabled': item.received_quantity === 0,
                                }]),
                                            onClick: ($event: any) => (_ctx.editDoubleSaleArticle(index))
                                          }, _hoisted_35, 10, _hoisted_33),
                                          _createElementVNode("span", {
                                            class: "el-input-number__increase",
                                            role: "button",
                                            onClick: ($event: any) => (_ctx.editDoubleSaleArticleAdd(index))
                                          }, _hoisted_38, 8, _hoisted_36),
                                          _createVNode(_component_el_input_number, {
                                            class: "w-125px",
                                            modelValue: item.received_quantity,
                                            "onUpdate:modelValue": ($event: any) => ((item.received_quantity) = $event),
                                            min: 
                                  _ctx.getDoubleSaleArticleItemGuids(index).length
                                ,
                                            controls: false
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "min"])
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                          _createVNode(_component_edit_double_sale_article_guid, {
                                            guids: _ctx.options.guids,
                                            onResetForm: _ctx.hideEditDoubleSaleArticle,
                                            onUpdateList: _ctx.updateDoubleSaleArticle
                                          }, null, 8, ["guids", "onResetForm", "onUpdateList"])
                                        ])), [
                                          [_directive_clickOutSide, _ctx.hideEditDoubleSaleArticle]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "visible"])
                                  ]))
                                : (_openBlock(), _createBlock(_component_el_input_number, {
                                    key: 1,
                                    class: "w-125px",
                                    modelValue: item.received_quantity,
                                    "onUpdate:modelValue": ($event: any) => ((item.received_quantity) = $event),
                                    precision: 0,
                                    step: 1,
                                    min: 0,
                                    size: "small"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(item.received_quantity), 1)),
                        (item.to_be_inspection_num > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.t("inspection.toBeInspection", [
                          item.to_be_inspection_num,
                        ])), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(item.missing_quantity), 1),
                  _createElementVNode("td", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", null, _toDisplayString(item.stocked_quantity), 1),
                      (item.to_be_stock > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.t("inspection.toBeStocked", [item.to_be_stock])), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_45, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_46, [
                      (_ctx.formData.print === 1)
                        ? (_openBlock(), _createBlock(_component_el_popover, {
                            key: 0,
                            placement: "top",
                            width: "auto",
                            trigger: "hover"
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                disabled: item.printDisabled || item.qtyRecords <= 0,
                                onClick: ($event: any) => (_ctx.getPrintedSheet(0, item))
                              }, [
                                _withDirectives(_createElementVNode("span", null, _hoisted_49, 512), [
                                  [_vShow, item.printDisabled]
                                ]),
                                _withDirectives(_createElementVNode("span", _hoisted_50, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                                ], 512), [
                                  [_vShow, !item.printDisabled]
                                ])
                              ], 8, _hoisted_47)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("inspection.printStockInLabel")) + " ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])), [
                      [_directive_auth, { auth: ['export'] }]
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.formData.article.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.t("common.noData")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.t("order.grandTotalBase")), 1),
                _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.getStockInTotalQty.demandQty), 1),
                (_ctx.isEditStockIn)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.getStockInTotalQty.receivedQty), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(_ctx.getStockInTotalQty.receivedQty), 1)),
                _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.getStockInTotalQty.missingQty), 1),
                _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.getStockInTotalQty.stockedQty), 1),
                _hoisted_61
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
            default: _withCtx(() => [
              (_ctx.formData.submit_qc_flag === 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    disabled: _ctx.isDisabledSubmitQc,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitQuality && _ctx.submitQuality(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                          _createElementVNode("span", _hoisted_65, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.submitQc")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_66, [
                          _hoisted_67,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_63))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stockIn && _ctx.stockIn(...args))),
                disabled: _ctx.loading
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                      _createElementVNode("span", _hoisted_70, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm002.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.stockIn")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_71, [
                      _hoisted_72,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_68), [
                [_vShow, 0]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspection.mismatched")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("table", _hoisted_77, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_78, [
                _createElementVNode("th", _hoisted_79, _toDisplayString(_ctx.t("order.article")), 1),
                _hoisted_80,
                _createElementVNode("th", _hoisted_81, _toDisplayString(_ctx.t("order.qty")), 1),
                _createElementVNode("th", _hoisted_82, _toDisplayString(_ctx.t("common.action")), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_83, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.mismatched, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    (item.scan_number)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("span", _hoisted_87, [
                                _createElementVNode("span", _hoisted_88, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen006.svg" })
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_product_info, {
                          key: 1,
                          gallery: item.gallery,
                          name: item.name,
                          name_en: item.name_en,
                          source_link: '',
                          brand_id: item.__show.brand_id
                        }, null, 8, ["gallery", "name", "name_en", "brand_id"]))
                  ]),
                  _createElementVNode("td", null, [
                    (item.scan_number)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(item.scan_number), 1))
                      : (_openBlock(), _createBlock(_component_sku_info, {
                          key: 1,
                          brand_article_no: item.brand_article_no,
                          merchant_article_no: item.merchant_article_no,
                          color: item.original_color,
                          size: item.__show.size,
                          capacity: item.__show.capacity,
                          product_identifier_id: item.product_identifier_id
                        }, null, 8, ["brand_article_no", "merchant_article_no", "color", "size", "capacity", "product_identifier_id"]))
                  ]),
                  _createElementVNode("td", _hoisted_90, [
                    (_ctx.isEditStockIn)
                      ? (_openBlock(), _createBlock(_component_el_input_number, {
                          key: 0,
                          class: "w-125px",
                          modelValue: item.qty,
                          "onUpdate:modelValue": ($event: any) => ((item.qty) = $event),
                          precision: 0,
                          step: 1,
                          min: 0,
                          size: "small"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(item.qty), 1))
                  ]),
                  _createElementVNode("td", _hoisted_92, [
                    (_ctx.formData.print === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                            default: _withCtx(() => [
                              (
                        _ctx.formData.inspection_status ===
                          _ctx.InspectionStatus.Pending && !item.isAdd
                      )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_mismatched_sku",
                                    onClick: ($event: any) => (_ctx.editMismatchedSku(item))
                                  }, [
                                    _createElementVNode("span", _hoisted_95, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                    ])
                                  ], 8, _hoisted_94))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (_ctx.formData.mismatched.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_96, [
                    _createElementVNode("td", _hoisted_97, _toDisplayString(_ctx.t("common.noData")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_98, [
          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
            default: _withCtx(() => [
              (_ctx.isEditStockIn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    disabled: _ctx.loading,
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkedStockIn && _ctx.checkedStockIn(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_100, [
                          _createElementVNode("span", _hoisted_101, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.checked")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_102, [
                          _hoisted_103,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_99))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
            default: _withCtx(() => [
              (_ctx.formData.print === 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    disabled: _ctx.loading,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getPrintedSheetAll && _ctx.getPrintedSheetAll(...args)))
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_105, [
                          _createElementVNode("span", _hoisted_106, [
                            _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/prints.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.printAllLables")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_107, [
                          _hoisted_108,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                        ]))
                  ], 8, _hoisted_104))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_109, [
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspection.missing")), 1),
          _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.t("inspection.goodsMissingNumber", [_ctx.getMissingQtyTotal])), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("table", _hoisted_113, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_114, [
              _createElementVNode("th", _hoisted_115, _toDisplayString(_ctx.t("order.article")), 1),
              _hoisted_116,
              _createElementVNode("th", null, _toDisplayString(_ctx.t("salesOrder.orderNumber")), 1),
              _createElementVNode("th", _hoisted_117, _toDisplayString(_ctx.t("order.qty")), 1),
              _createElementVNode("th", _hoisted_118, _toDisplayString(_ctx.t("inspection.result")), 1),
              _createElementVNode("th", _hoisted_119, _toDisplayString(_ctx.t("common.action")), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_120, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.missing, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_product_info, {
                    gallery: item.gallery,
                    name: item.name,
                    name_en: item.name_en,
                    source_link: '',
                    brand_id: item.__show.brand_id
                  }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_sku_info, {
                    brand_article_no: item.brand_article_no,
                    merchant_article_no: item.merchant_article_no,
                    color: item.original_color,
                    size: item.__show.size,
                    capacity: item.__show.capacity,
                    product_identifier_id: item.product_identifier_id
                  }, null, 8, ["brand_article_no", "merchant_article_no", "color", "size", "capacity", "product_identifier_id"])
                ]),
                _createElementVNode("td", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.order_info, (row, rowIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: rowIndex }, [
                        (row.position !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                              _createElementVNode("div", null, _toDisplayString(row.order_number), 1),
                              _createElementVNode("div", _hoisted_124, " SUB#" + _toDisplayString(row.position) + " (" + _toDisplayString(row.count) + ") ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_125, _toDisplayString(item.qty), 1),
                _createElementVNode("td", _hoisted_126, [
                  _createElementVNode("span", _hoisted_127, _toDisplayString(item.__show.inspection_result), 1)
                ]),
                _createElementVNode("td", _hoisted_128, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_129, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_missing_result",
                      onClick: ($event: any) => (_ctx.editMissingResult(item))
                    }, [
                      _createElementVNode("span", _hoisted_131, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                      ])
                    ], 8, _hoisted_130)
                  ])), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.formData.missing.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_132, [
                  _createElementVNode("td", _hoisted_133, _toDisplayString(_ctx.t("common.noData")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_InboundReceivingPackageModal, {
      ref: "receivingPackageRef",
      subTitle: _ctx.inspectionFormData.warehouse_name,
      onUpdateList: _ctx.debounceScan,
      submitType: 2
    }, null, 8, ["subTitle", "onUpdateList"]),
    _createVNode(_component_update_double_sale_article, {
      ref: "updateDoubleSaleArticleModalRef",
      onUpdateList: _ctx.updateDoubleSaleArticle
    }, null, 8, ["onUpdateList"]),
    _createVNode(_component_mismatched_sku, {
      id: String(_ctx.itemId),
      scanNumber: String(_ctx.itemScanNumber),
      checkedDate: _ctx.formData.checked_date,
      checkedUser: _ctx.formData.__show.checked_user,
      onUpdateList: _ctx.getFromInfo
    }, null, 8, ["id", "scanNumber", "checkedDate", "checkedUser", "onUpdateList"]),
    _createVNode(_component_missing_result, {
      id: String(_ctx.itemId),
      result: Number(_ctx.itemResult),
      "max-qty": _ctx.itemQty,
      "batch-number": _ctx.inspectionFormData.batch_number,
      onUpdateList: _ctx.getFromInfo
    }, null, 8, ["id", "result", "max-qty", "batch-number", "onUpdateList"]),
    _createVNode(_component_exception_product, {
      ref: "exceptionProductRef",
      onUpdateList: _ctx.getExceptionProduct
    }, null, 8, ["onUpdateList"]),
    _createVNode(_component_print_preview, { ref: "printPreviewRef" }, null, 512)
  ], 64))
}